module.exports = __webpack_public_path__ + "static/media/success.b6e08bef.svg";